import { appConfig } from '../../../config/customization';

const BUTTON_SIZE = 15;

const buttonStyle = {
  borderWidth: 2,
  borderRadius: 5,
  borderStyle: 'solid',
  margin: 10,
  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
  width: BUTTON_SIZE,
  height: BUTTON_SIZE
};

export default {
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  inactiveButton: {
    ...buttonStyle,
    background: appConfig.colors.white,
    borderColor: appConfig.colors.gray
  },
  activeButton: {
    ...buttonStyle,
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundColor: appConfig.colors.primary,
    borderColor: appConfig.colors.primary
  },
  checkedOk: {
    strokeWidth: 2.4,
    stroke: appConfig.colors.checkedOk,
    fill: 'none',
    marginRight: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};
